import { render, staticRenderFns } from "./emailMarketing.vue?vue&type=template&id=f124e852&"
import script from "./emailMarketing.vue?vue&type=script&lang=js&"
export * from "./emailMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports